import { render, staticRenderFns } from "./CPDueDiligenceConfirmation.vue?vue&type=template&id=23af8e7f&scoped=true&"
import script from "./CPDueDiligenceConfirmation.vue?vue&type=script&lang=ts&"
export * from "./CPDueDiligenceConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./CPDueDiligenceConfirmation.vue?vue&type=style&index=0&id=23af8e7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23af8e7f",
  null
  
)

export default component.exports